<template>
  <div>
    <a-modal v-model="modalVisible" :destroy-on-close="true" width="500px" :title="isEdit ? '编辑' : '新增'" @cancel="close" @ok="onOk">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item label="人员配置" prop="userList">
          <a-select v-model="form.userList" mode="multiple" allow-clear placeholder="请选人员" show-search :filter-option="utils.filterOption">
            <a-select-option v-for="(user, index) in $store.state.allUsers" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { queryBusinessRequirement } from '@/api/business/requirement';

export default {
  components: { },
  props: {
    selectedKey: {
      type: String,
      default: ''
    },
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      form: {
        userList: []
      },
      rules: {
        userList: [{ required: true, message: '人员不能为空', trigger: 'blur' }]
      },
      modalVisible: false,
      loading: false,
      title: '新增',
      isEdit: false
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    close() {
      this.modalVisible = false;
      this.form = {
        userList: []
      };
    },
    open(_isEdit) {
      this.isEdit = _isEdit;
      this.modalVisible = true;
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const orgUList = JSON.parse(JSON.stringify(this.dataList));
          const uList = this.form.userList || [];
          uList.forEach(item => {
            const orgUser = orgUList.find(it => it.user_id === item);
            if (!orgUser) {
              // 如果不存在，进行新增处理
              const usr = this.$store.state.allUsers.find(u => u.id === item);
              if (usr) {
                orgUList.push({ fs_user_id: usr.fs_user_id, nickname: usr.nickname, user_id: usr.id });
              }
            }
          });
          console.log(this.selectedKey, orgUList);
          this.$emit('ok');
          this.close();
        }
      });
    }

  }
};
</script>
